/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { Currency } from '@app/settings/currencies/currency.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CurrenciesService } from '@app/settings/currencies/currencies.service';

@Component({
  selector: 'app-currencies-form',
  templateUrl: './currencies-form.component.html',
  styleUrls: ['./currencies-form.component.scss'],
})
export class CurrenciesFormComponent implements OnInit {
  @Input() currency: Currency = null;

  form: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private currencyService: CurrenciesService
  ) {}

  ngOnInit() {
    this.createForm();
  }

  save() {
    if (this.currency && this.currency.id) {
      const currency: Currency = this.currency.deserialize(this.form.value);
      this.currencyService.update(currency).subscribe((res) => this.modal.close('Save click'));
    } else {
      const currency: Currency = new Currency().deserialize(this.form.value);
      this.currencyService.store(currency).subscribe((res) => this.modal.close(res));
    }
  }

  private createForm() {
    this.form = this.formBuilder.group({
      code: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
    });

    if (this.currency && this.currency.id) {
      this.form = this.formBuilder.group({
        name: [null, [Validators.required]],
        code: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
        symbol: [null, [Validators.required]],
        format: [null, [Validators.required]],
        exchange_rate: [null, [Validators.required]],
        order_index: [null],
        active: [true],
      });
    }

    if (this.currency && this.currency.id) {
      this.currencyService.show(this.currency.id).subscribe((currency: Currency) => {
        this.form.patchValue(currency);
      });
    } else if (this.currency) {
      this.form.patchValue(this.currency);
    }
  }
}
